<template>
    <div class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">
            <div class="h-100">
                <div class="content_calendar_option">
                    <div class="calendar_config">
                        <v-btn variant="outlined" @click="returnToday()" class="ml-4">Hoy</v-btn>
                        <v-btn icon="mdi-chevron-left" class="ml-2" variant="text" @click="previousCalendar()"></v-btn>
                        <v-btn icon="mdi-chevron-right" class="ml-1" variant="text" @click="nextCalendar()"></v-btn>

                        <div class="date_selected"> 
                            <span v-if="typeCalendar === 'Día'">
                                {{ weekDay[getDateSelected.getDay()].week }} {{ getDateSelected.getDate() }} de
                            </span>                            
                            {{ months[getDateSelected.getMonth()] }} de {{ getDateSelected.getFullYear() }}
                        </div>
                    </div>
                    <div>
                        <v-btn id="menu-activator" variant="outlined" class="mr-4">
                            {{ typeCalendar }}
                        </v-btn>
                        <v-menu activator="#menu-activator">
                            <v-list>
                                <v-list-item @click="configTypeCalendar('Día')">
                                    <v-list-item-title>Día</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="configTypeCalendar('Semana')">
                                    <v-list-item-title>Semana</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="configTypeCalendar('Mes')">
                                    <v-list-item-title>Mes</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </div>
                <div class="content_calendar_data">
                    <div class="options">
                        <!-- <v-date-picker 
                            width="350" 
                            :hide-header="true"
                            v-model="dateSelected"
                            @update:model-value="redirectDate()"
                        ></v-date-picker> -->

                        <div style="padding: 20px 20px 0 20px;" v-if="permission.filterCalendar">
                            <v-autocomplete
                                v-model="idCurrentUser"
                                @update:model-value="changeUser()"
                                label="Usuario"
                                variant="outlined"
                                :items="arrUsers"
                                item-title="NAME_COMPLETE"
                                item-value="ID"
                                prepend-inner-icon="mdi-magnify"
                            >
                            </v-autocomplete>
                        </div>
                        <div style="display: flex; flex-direction: column; margin-left: 15px;">

                            <v-switch
                                @click="updateAllOptions()" 
                                v-model="optionAll" 
                                color="#000000" 
                                hide-details 
                                label="Seleccionar Todos">
                            </v-switch>

                            <v-switch
                                @change="updateOption()" 
                                v-model="optionCanceledAgreements" 
                                color="#0D47A1" 
                                hide-details 
                                label="Convenios / Liquidaciones Canceladas">
                            </v-switch>
                            <v-switch
                                @change="updateOption()" 
                                v-model="optionPendingAgreements" 
                                color="#FFB74D" 
                                hide-details 
                                label="Convenios / Liquidaciones Generadas">
                            </v-switch>
                            <v-switch
                                @change="updateOption()" 
                                v-model="optionContactManagement" 
                                color="#7C4DFF" 
                                hide-details 
                                label="Gestiones de Contacto">
                            </v-switch>
                            <v-switch
                                @change="updateOption()" 
                                v-model="optionIntention" 
                                color="#EC407A" 
                                hide-details 
                                label="Intención">
                            </v-switch>
                            <v-switch
                                @change="updateOption()" 
                                v-model="optionPendingLiquidations" 
                                color="#3FCC1C" 
                                hide-details 
                                label="Liquidaciones Pendientes">
                            </v-switch>
                            <v-switch
                                @change="updateOption()" 
                                v-model="optionPendingpayments" 
                                color="#DC1818" 
                                hide-details 
                                label="Pagos Pendientes">
                            </v-switch>
                            <v-switch
                                @change="updateOption()" 
                                v-model="optionSettlementsMade" 
                                color="#35530E" 
                                hide-details 
                                label="Liquidaciones Realizadas">
                            </v-switch>
                            <v-switch
                                @change="updateOption()" 
                                v-model="optionPaymentsMade" 
                                color="#999494" 
                                hide-details 
                                label="Pagos Realizados">
                            </v-switch>
                        </div>

                    </div>
                    <div class="calendar">
                        <div v-if="typeCalendar === 'Día'">
                            <div class="item_date_week">
                                <div :class="getDateSelected.getTime() === currentDate.getTime() ? 'number_day-current_date' : 'number_day'">
                                    {{ weekDay[getDateSelected.getDay()].acronym }}
                                </div>
                                <div :class="getDateSelected.getTime() === currentDate.getTime() ? 'number_date-current_date' : 'number_date'">
                                    <div>{{ getDateSelected.getDate() }}</div>
                                </div>
                            </div>
                            <div class="container_time">
                                <div class="content_times">
                                    <div class="item_time" v-for="time in arrTimes" :key="time">
                                        {{ time.show }}
                                    </div>
                                </div>
                                <div class="content_data_time">
                                    <div class="item_data_time" v-for="date in this.arrDataDate" :key="date">
                                        <div class="info_date" v-for="info in date.dataHour" :key="info" :style="{ background: info.color }" @click="openDetails(info)">
                                            {{ info.hora_objeto }} | {{ info.id_cliente }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="typeCalendar === 'Semana'">
                            <div class="content_week_data">
                                <div class="item_week_data" v-for="week in arrWeek" :key="week">
                                    <div :class="week.getTime() === currentDate.getTime() ? 'number_day-current_date' : 'number_day'">
                                        {{ weekDay[week.getDay()].acronym }}
                                    </div>
                                    <div :class="week.getTime() === currentDate.getTime() ? 'number_date-current_date' : 'number_date'">
                                        <div>{{ week.getDate() }}</div>
                                    </div>
                                        
                                </div>
                            </div>
                            <div class="h-100">
                                <div class="container_time">
                                    <div class="content_times">
                                        <div class="item_time" v-for="time in arrTimes" :key="time">
                                            {{ time.show }}
                                        </div>
                                    </div>
                                    <div class="content_data_week">

                                        <div class="item_week_date" v-for="weeks in arrDataWeeks" :key="weeks">
                                            <div class="item_data_time" v-for="hourData in weeks.dataDates" :key="hourData">
                                                <div class="info_date" v-for="info in hourData.dataHour" :key="info" :style="{ background: info.color }" @click="openDetails(info)">
                                                    {{ info.hora_objeto }} | {{ info.id_cliente }}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="h-100" v-if="typeCalendar === 'Mes'">
                            <div class="container_calendar" v-if="!isLoadingCalendar">
                                <div class="content_day">
                                    <div class="item_week" v-for="week in weekDay" :key="week"> {{ week.acronym }} </div>
                                </div>
                                <div class="content_week" v-for="calendarMonth in arrCalendarMonth" :key="calendarMonth">
                                    <div class="item_date" v-for="date in calendarMonth" :key="date">

                                        <div v-if="date.date.getTime() === currentDate.getTime()" class="item_day-current_date">
                                            {{ date.date.getDate() }}
                                        </div>
                                        <div v-else-if="date.isDate" class="item_day">
                                            {{ date.date.getDate() }}
                                        </div>
                                        <div v-else-if="!date.isDate" class="item_day-another_date">
                                            {{ date.date.getDate() }}
                                        </div>
                                        <div class="w-100">
                                            <div class="info_date" v-for="info in date.info" :key="info" :style="{ background: info.color }" @click="openDetails(info)">
                                                {{ info.hora_objeto }} | {{ info.id_cliente }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="content_load" v-if="isLoadingCalendar">
                                <v-progress-circular
                                    :size="100"
                                    :width="7"
                                    color="indigo-darken-3"
                                    indeterminate
                                ></v-progress-circular>
                                <i>Espere un momento</i>
                                <div>Cargando calendario</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-card>
    </div>
    <template>
      <v-dialog v-model="dialogDetails" width="500px" persistent>
          <v-card>
              <v-card-title>
                  <span class="text-h5">Detalles - {{ infoDetails.tipo }}</span>
              </v-card-title>
              <v-card-text>
                <form class="override_content_flex">
                    <div class="col-flex-12">
                        <v-text-field
                            label="Folio Gen"
                            variant="outlined"
                            v-model="infoDetails.folioGen"
                            readonly
                            class="w-100"
                        ></v-text-field>
                    </div>
                    <div class="col-flex-12">
                        <v-text-field
                            label="Fecha"
                            variant="outlined"
                            v-model="infoDetails.fecha_calendario"
                            readonly
                            class="w-100"
                        ></v-text-field>
                    </div>
                    <div class="col-flex-12">
                        <v-text-field
                            label="ID Cliente"
                            variant="outlined"
                            v-model="infoDetails.id_cliente"
                            readonly
                            class="w-100"
                        ></v-text-field>
                    </div>
                    <div class="col-flex-12">
                        <v-text-field
                            label="Nombre del Cliente"
                            variant="outlined"
                            v-model="infoDetails.nombre"
                            readonly
                            class="w-100"
                        ></v-text-field>
                    </div>
                    <div class="col-flex-12">
                        <v-text-field
                            label="Comentarios"
                            variant="outlined"
                            v-model="infoDetails.comentario"
                            readonly
                            class="w-100"
                        ></v-text-field>
                    </div>
                </form>
              </v-card-text>
              <v-card-actions class="actions_buttons">
                  <v-btn class="text-none" color="warn" @click="dialogDetails = false;">Cerrar</v-btn>
                  <v-btn class="text-none" color="indigo-darken-3" @click="redirectClient(infoDetails.id_cliente)">Ver cliente</v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
    </template>
    <SnackbarComponent :value="snackbarData"/>
</template>

<script>
    import { CalendarService } from '@/services/CalendarService'
    import { EncryptService } from '@/services/EncryptService'
    import { UserManagementService } from '@/services/UserManagementService'

    export default {
        name: 'CalendarView',
        data ()  {
            return {
                isLoading: false,
                isLoadingCalendar: false,

                dialogDetails: false,

                currentDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                dateSelected: new Date(),
                typeCalendar: 'Mes',
                weekDay: [
                    {
                        week: 'Domingo',
                        acronym: 'Dom'
                    }, 
                    {
                        week: 'Lunes',
                        acronym: 'Lun'
                    }, 
                    {
                        week: 'Martes',
                        acronym: 'Mar'
                    }, 
                    {
                        week: 'Miércoles',
                        acronym: 'Mié'
                    }, 
                    {
                        week: 'Jueves',
                        acronym: 'Jue'
                    }, 
                    {
                        week: 'Viernes',
                        acronym: 'Vie'
                    }, 
                    {
                        week:  'Sábado',
                        acronym: 'Sáb'
                    }
                ],
                months: [
                    'Enero',
                    'Febrero',
                    'Marzo',
                    'Abril',
                    'Mayo',
                    'Junio',
                    'Julio',
                    'Agosto',
                    'Septiembre',
                    'Octubre',
                    'Noviembre',
                    'Diciembre'
                ],
                arrTimes: [],
                arrWeek: [],
                snackbarData: {
                    openSnackbar: false,
                    description: '',
                },
                arrUsers: [],
                idCurrentUser: 0,
                filterUser: '',

                optionCanceledAgreements: false,
                optionPendingAgreements: false,
                optionContactManagement: false,
                optionIntention: false,
                optionPendingLiquidations: false,
                optionPendingpayments: false,
                optionSettlementsMade: false,
                optionPaymentsMade: false,

                arrCalendarMonth: [],
                arrDataCalendar: null,
                infoDetails: null,
                isLoadCalendar: false,

                arrDataWeeks: [],
                arrDataDate: [],

                typeUser: '',

                permission: {
                    filterCalendar: false,
                },

                optionAll: 0,
            }
        },
        computed: {
            getDateSelected() {
                return new Date(this.dateSelected.getFullYear(), this.dateSelected.getMonth(), this.dateSelected.getDate());
            }
        },
        async created () {
            let idUser = localStorage.getItem('ID')
            this.idCurrentUser = parseInt(idUser)

            const ENC_TIPO = localStorage.getItem('TIPO')
            const TIPO = await EncryptService.decrypt(ENC_TIPO)
            this.typeUser = TIPO
            this._generateTimes()
            await this._getUserManagement()

            const ENC_PERMISOS = localStorage.getItem('PERMISOS')
            const STR_PERMISOS = atob(ENC_PERMISOS)
            const ARR_PERMISOS = JSON.parse(STR_PERMISOS)
            const PERMISSION = ARR_PERMISOS.find((permission) => permission.modulo === 'M08CALE')
            for (const element of PERMISSION.endpoints) {
                if (element.nombre === 'M08F01FICA' && element.permiso === true) {
                    this.permission.filterCalendar = true
                }
            }
        },
        methods: {
            _getCalendar: async function () {
                if (this.idCurrentUser === null || this.idCurrentUser === undefined) {
                    return;
                }
                this.isLoadingCalendar = true;
                let month = this.dateSelected.getMonth() + 1; 
                month = month < 10 ? `0${month}` : `${month}`;
                let year = this.dateSelected.getFullYear();

                const ENC_IDUSER = await EncryptService.encrypt(this.idCurrentUser.toString())
                await CalendarService.getCalendar(ENC_IDUSER, month, year).then(
                    (responseData) => {
                        //console.log("->> ",responseData)
                        if (!responseData.error) {
                            this.arrDataCalendar = responseData.response
                        } else {
                            this.snackbarData.description = responseData.msg
                            this.snackbarData.openSnackbar = true
                        }
                    }
                )
                this.isLoadingCalendar = false;
            },
            _generateTimes: function () {
                this.arrTimes = [];
                let periodicidy = 'AM';
                for (let hour = 8; hour < 13; hour++) {
                    this.arrTimes.push({
                        show: `${hour} ${periodicidy}`,
                        hour: periodicidy === 'PM' ? hour + 12 : hour
                    })
                    if (periodicidy === 'AM' && hour === 12) {
                        hour = 0;
                        periodicidy = 'PM';
                    }
                }
                this.arrTimes.pop();
            },
            _getUserManagement: async function () {
                const ENC_IDUSER = await EncryptService.encrypt(this.idCurrentUser.toString())
                await UserManagementService.getUserManagement(ENC_IDUSER).then(
                    (responseData) => {
                        if (!responseData.error) {
                            this.arrUsers = [];
                            for (const element of responseData.response) {
                                if (element.status === 'Activo') {
                                    this.arrUsers.push({
                                        ID: element.id,
                                        USERNAME: element.username,
                                        NAME_COMPLETE: `${element.name} (${element.username})`,
                                        TIPO_USUARIO: element.tipo,
                                    })
                                }
                                if (element.id === this.idCurrentUser) {
                                    this.filterUser = `${element.name} ${element.last_name} (${element.id})`;
                                }
                            }
                            this.isLoadCalendar = false
                            this.configTypeCalendar('Mes')
                        } else {
                            this.snackbarData.description = responseData.msg
                            this.snackbarData.openSnackbar = true
                        }
                    }
                )
            },
            configTypeCalendar: async function (type) {
                this.typeCalendar = type;
                switch (type) {
                    case 'Día':
                        await this._generateDate()
                        break;
                    case 'Semana':
                        await this._generateWeek()
                        break;
                    case 'Mes':
                        await this._generateCalendar()
                        break;
                }
            },
            returnToday: async function () {
                this.dateSelected = new Date();
                switch (this.typeCalendar) {
                case 'Día':
                    await this._generateDate()
                    break;
                case 'Semana':
                    await this._generateWeek()
                    break;
                case 'Mes':
                    await this._generateCalendar()
                    break;
                }
            },
            previousCalendar: async function () {

                let lastDateSelected = this.dateSelected;
                switch (this.typeCalendar) {
                    case 'Día':
                        this.dateSelected = new Date(this.dateSelected.getTime() - (24 * 60 * 60 * 1000))

                        if (lastDateSelected.getMonth() !== this.dateSelected.getMonth()) {
                            this.optionAll = false
                            this.optionCanceledAgreements = false
                            this.optionPendingAgreements = false
                            this.optionContactManagement = false
                            this.optionIntention = false
                            this.optionPendingLiquidations = false
                            this.optionPendingpayments = false
                            this.optionPaymentsMade = false
                            this.optionSettlementsMade = false

                            this.isLoadCalendar = false
                        }

                        await this._generateDate()
                        break;
                    case 'Semana':
                        this.dateSelected = new Date(this.dateSelected.getTime() - (7 * 24 * 60 * 60 * 1000))
                        if (lastDateSelected.getMonth() !== this.dateSelected.getMonth()) {
                            this.optionAll = false
                            this.optionCanceledAgreements = false
                            this.optionPendingAgreements = false
                            this.optionContactManagement = false
                            this.optionIntention = false
                            this.optionPendingLiquidations = false
                            this.optionPendingpayments = false
                            this.optionPaymentsMade = false
                            this.optionSettlementsMade = false

                            this.isLoadCalendar = false
                        }
                        await this._generateWeek()
                        break;
                    case 'Mes':
                        this.dateSelected = new Date(this.dateSelected.getFullYear(), this.dateSelected.getMonth() - 1, 1)
                        this.optionAll = false
                        this.optionCanceledAgreements = false
                        this.optionPendingAgreements = false
                        this.optionContactManagement = false
                        this.optionIntention = false
                        this.optionPendingLiquidations = false
                        this.optionPendingpayments = false
                        this.optionPaymentsMade = false
                        this.optionSettlementsMade = false

                        this.isLoadCalendar = false
                        await this._generateCalendar()

                        break;
                }
            },
            nextCalendar: async function () {
                let lastDateSelected = this.dateSelected;
                
                switch (this.typeCalendar) {
                    case 'Día':
                        this.dateSelected = new Date(this.dateSelected.getTime() + (24 * 60 * 60 * 1000))
                        if (lastDateSelected.getMonth() !== this.dateSelected.getMonth()) {
                            this.optionAll = false
                            this.optionCanceledAgreements = false
                            this.optionPendingAgreements = false
                            this.optionContactManagement = false
                            this.optionIntention = false
                            this.optionPendingLiquidations = false
                            this.optionPendingpayments = false
                            this.optionPaymentsMade = false
                            this.optionSettlementsMade = false

                            this.isLoadCalendar = false
                        }
                        await this._generateDate()
                        break;
                    case 'Semana':
                        this.dateSelected = new Date(this.dateSelected.getTime() + (7 * 24 * 60 * 60 * 1000))
                        if (lastDateSelected.getMonth() !== this.dateSelected.getMonth()) {
                            this.optionAll = false
                            this.optionCanceledAgreements = false
                            this.optionPendingAgreements = false
                            this.optionContactManagement = false
                            this.optionIntention = false
                            this.optionPendingLiquidations = false
                            this.optionPendingpayments = false
                            this.optionPaymentsMade = false
                            this.optionSettlementsMade = false

                            this.isLoadCalendar = false
                        }
                        await this._generateWeek()
                        break;
                    case 'Mes':
                        
                        this.dateSelected = new Date(this.dateSelected.getFullYear(), this.dateSelected.getMonth() + 1, 1)
                        
                        this.optionAll = false
                        this.optionCanceledAgreements = false
                        this.optionPendingAgreements = false
                        this.optionContactManagement = false
                        this.optionIntention = false
                        this.optionPendingLiquidations = false
                        this.optionPendingpayments = false
                        this.optionPaymentsMade = false
                        this.optionSettlementsMade = false

                        this.isLoadCalendar = false
                        await this._generateCalendar()
                        break;
                }


            },
            updateOption: async function () {
                switch (this.typeCalendar) {
                    case 'Día':
                        await this._generateDate()
                        break;
                    case 'Semana':
                        await this._generateWeek()
                        break;
                    case 'Mes':
                        await this._generateCalendar()
                        break;
                }
            },
            _generateCalendar: async function () {                
                if (!this.isLoadCalendar) {
                    await this._getCalendar();
                    this.isLoadCalendar = true
                }
                const YEAR_SLT = this.dateSelected.getFullYear();
                const MONTH_SLT = this.dateSelected.getMonth();

                const FIRST_DATE = new Date(YEAR_SLT, MONTH_SLT, 1);
                const END_DATE = new Date(YEAR_SLT, MONTH_SLT+1, 0);

                let arrStartCalendar = [];
                let arrEndCalendar = [];
                for (let day = 0; day < 7; day++) {
                    if (day < FIRST_DATE.getDay()) {
                        let diffDay = FIRST_DATE.getDay() - day;
                        let previuosDate = new Date(FIRST_DATE);
                        previuosDate.setDate(FIRST_DATE.getDate() - diffDay);
                        arrStartCalendar.push({
                            isDate: false,
                            date: previuosDate
                        });
                    }

                    if (day > END_DATE.getDay()) {
                        let diffDay = day - END_DATE.getDay();
                        let nextDate = new Date(END_DATE);
                        nextDate.setDate(END_DATE.getDate() + diffDay);
                        arrEndCalendar.push({
                            isDate: false,
                            date: nextDate
                        });
                    }
                }

                this.arrCalendarMonth = [];
                let numWeeks = 0;
                this.arrCalendarMonth[numWeeks] = [];
                for (let date = FIRST_DATE.getDate(); date <= END_DATE.getDate(); date++) {
                    const DATE_MONTH = new Date(YEAR_SLT, MONTH_SLT, date)
                    
                    let itemsCalendar = {
                        isDate: true,
                        date: DATE_MONTH,
                        info: [],
                    }
                    if (this.optionCanceledAgreements) {
                        for (const element of this.arrDataCalendar.convenios_cancelados) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : minutes
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`
                            if (DATE_MONTH.getTime() === DATE_VALIDATE.getTime()) {
                                itemsCalendar.info.push({
                                    tipo: 'Convenio Cancelado',
                                    color: '#0D47A1',
                                    id_convenio: element.id_convenio,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE
                                })
                            }
                        }
                    }
                    if (this.optionPendingAgreements) {
                        for (const element of this.arrDataCalendar.convenios_pendientes) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : minutes
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`
                            if (DATE_MONTH.getTime() === DATE_VALIDATE.getTime()) {
                                itemsCalendar.info.push({
                                    tipo: 'Convenios Pendientes',
                                    color: '#FFB74D',
                                    id_convenio: element.id_convenio,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE
                                })
                            }
                        }
                    }
                    if (this.optionContactManagement) {
                        for (const element of this.arrDataCalendar.gestiones_contacto) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : minutes
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                            if (DATE_MONTH.getTime() === DATE_VALIDATE.getTime()) {

                                itemsCalendar.info.push({
                                    tipo: 'Gestiones Contacto',
                                    color: '#7C4DFF',
                                    id_gestion: element.id_gestion,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE
                                })
                            }
                        }
                    }
                    if (this.optionIntention) {
                        for (const element of this.arrDataCalendar.intencion) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : minutes
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`
                            if (DATE_MONTH.getTime() === DATE_VALIDATE.getTime()) {
                                itemsCalendar.info.push({
                                    tipo: 'Intención',
                                    color: '#EC407A',
                                    id_intencion: element.id_intencion,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    fecha_calendario: element.fecha_calendario,
                                    id_cliente: element.id_cliente,
                                    nombre: element.nombre,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE
                                })
                            }
                        }
                    }
                    if (this.optionPendingLiquidations) {
                        for (const element of this.arrDataCalendar.liquidaciones_pendientes) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : minutes
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`
                            if (DATE_MONTH.getTime() === DATE_VALIDATE.getTime()) {
                                itemsCalendar.info.push({
                                    tipo: 'Liquidaciones Pendientes',
                                    color: '#3FCC1C',
                                    id_convenio: element.id_convenio,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE
                                })
                            }
                        }
                    }
                    if (this.optionPendingpayments) {
                        for (const element of this.arrDataCalendar.pagos_pendientes) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : minutes
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`
                            if (DATE_MONTH.getTime() === DATE_VALIDATE.getTime()) {
                                itemsCalendar.info.push({
                                    tipo: 'Pagos Pendientes',
                                    color: '#DC1818',
                                    id_convenio: element.id_convenio,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE
                                })
                            }
                        }
                    }
                    if(this.optionSettlementsMade){
                        for (const element of this.arrDataCalendar.liquidaciones_realizadas) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : minutes
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`
                            
                            if (DATE_MONTH.getTime() === DATE_VALIDATE.getTime()) {
                                itemsCalendar.info.push({
                                    tipo: 'Liquidaciones Realizadas',
                                    color: '#35530E',
                                    id_convenio: element.id_convenio,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE
                                })
                            }
                        }
                    }
                    if(this.optionPaymentsMade){
                        for (const element of this.arrDataCalendar.pagos_realizados) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : minutes
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`
                            if (DATE_MONTH.getTime() === DATE_VALIDATE.getTime()) {
                                itemsCalendar.info.push({
                                    tipo: 'Pagos Realizados',
                                    color: '#999494',
                                    id_convenio: element.id_convenio,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE
                                })
                            }
                        }
                    }

                    this.arrCalendarMonth[numWeeks].push(itemsCalendar)
                    
                    if (DATE_MONTH.getDay() === 6 && date < END_DATE.getDate() ) {
                        numWeeks++;
                        this.arrCalendarMonth[numWeeks] = [];
                    }
                }
                
                for (let numWeeks = 0; numWeeks < this.arrCalendarMonth.length; numWeeks++) {
                    let element = this.arrCalendarMonth[numWeeks];
                    if (numWeeks === 0 && element.length !== 7 && arrStartCalendar.length > 0) {
                        element = arrStartCalendar.concat(element)
                    }
                    if (numWeeks === this.arrCalendarMonth.length - 1 && element.length !== 7 && arrEndCalendar.length > 0) {
                        element = element.concat(arrEndCalendar)
                    }
                    this.arrCalendarMonth[numWeeks] = element;
                }
                this.arrCalendarMonth = this._filterCalendarHour(this.arrCalendarMonth);                
                
                this.isLoadingCalendar = false;
            },
            _filterCalendarHour: function (arrCalendarMonth) {
                
                for (const arrWeekElement of arrCalendarMonth) {
                    for (const element of arrWeekElement) {
                        if (element.info !== undefined && element.info.length > 0) {
                            const arrInfo = element.info;
                            arrInfo.sort((a, b) => this._horaToMillis(a.hora_objeto) - this._horaToMillis(b.hora_objeto));
                            element.info = arrInfo;
                        }
                        
                    }
                }
                return arrCalendarMonth;
            },
            _horaToMillis: function (hora) {
                const [hours, minutes, seconds] = hora.split(':').map(Number);
                return (hours * 3600 + minutes * 60 + seconds) * 1000;
            },
            _generateWeek: async function () {

                if (!this.isLoadCalendar) {
                    await this._getCalendar();
                    this.isLoadCalendar = true
                }

                this.arrWeek = [];
                for (let day = 0; day < 7; day++) {
                    if (day < this.dateSelected.getDay()) {
                        let diff = this.dateSelected.getDay() - day;
                        let previuosDate = new Date(this.dateSelected.getFullYear(), this.dateSelected.getMonth(), this.dateSelected.getDate());
                        previuosDate.setDate(this.dateSelected.getDate() - diff);
                        this.arrWeek.push(previuosDate);
                    } else if (day === this.dateSelected.getDay()) {
                        let currentDate = new Date(this.dateSelected.getFullYear(), this.dateSelected.getMonth(), this.dateSelected.getDate());
                        this.arrWeek.push(currentDate);
                    } else {
                        let diff = day - this.dateSelected.getDay();
                        let nextDate = new Date(this.dateSelected.getFullYear(), this.dateSelected.getMonth(), this.dateSelected.getDate());
                        nextDate.setDate(this.dateSelected.getDate() + diff);
                        this.arrWeek.push(nextDate);
                    }
                }

                this.arrDataWeeks = [];
                for (const week of this.arrWeek) {

                    let infoWeek = {
                        dateWeek: week,
                        dataDates: [],
                    }                    
                    for (const clock of this.arrTimes) {
                        let dataClock = {
                            hour: clock.hour,
                            dataHour: []
                        }
                        if (this.optionCanceledAgreements) {
                            for (const element of this.arrDataCalendar.convenios_cancelados) {
                                const DATE_CALENDAR = new Date(element.fecha_calendario)
                                const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                                let hours = DATE_CALENDAR.getHours()
                                hours = hours < 10 ? `0${hours}` : `${hours}`
                                let minutes = DATE_CALENDAR.getMinutes()
                                minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                                let seconds = DATE_CALENDAR.getSeconds()
                                seconds = seconds < 10 ? `0${seconds}` : seconds
                                const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                                const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                                if (week.getTime() === DATE_VALIDATE.getTime() && HOUR_WEEK === hours ) {
                                    dataClock.dataHour.push({
                                        tipo: 'Convenio Cancelado',
                                        color: '#0D47A1',
                                        id_convenio: element.id_convenio,
                                        id_gestion: element.id_gestion,
                                        folioGen: element.folioGen,
                                        nombre: element.nombre,
                                        id_cliente: element.id_cliente,
                                        fecha_calendario: element.fecha_calendario,
                                        comentario: element.comentario,
                                        fecha_objeto: DATE_VALIDATE,
                                        hora_objeto: TIME_VALIDATE,
                                        hora: hours,
                                    })
                                }
                            }
                        }
                        if (this.optionPendingAgreements) {
                            for (const element of this.arrDataCalendar.convenios_pendientes) {
                                const DATE_CALENDAR = new Date(element.fecha_calendario)
                                const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                                let hours = DATE_CALENDAR.getHours()
                                hours = hours < 10 ? `0${hours}` : `${hours}`
                                let minutes = DATE_CALENDAR.getMinutes()
                                minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                                let seconds = DATE_CALENDAR.getSeconds()
                                seconds = seconds < 10 ? `0${seconds}` : seconds
                                const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                                const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                                if (week.getTime() === DATE_VALIDATE.getTime() && HOUR_WEEK === hours ) {
                                    dataClock.dataHour.push({
                                        tipo: 'Convenios Pendientes',
                                        color: '#FFB74D',
                                        id_convenio: element.id_convenio,
                                        id_gestion: element.id_gestion,
                                        folioGen: element.folioGen,
                                        nombre: element.nombre,
                                        id_cliente: element.id_cliente,
                                        fecha_calendario: element.fecha_calendario,
                                        comentario: element.comentario,
                                        fecha_objeto: DATE_VALIDATE,
                                        hora_objeto: TIME_VALIDATE,
                                        hora: hours,
                                    })
                                }
                            }
                        }
                        if (this.optionContactManagement) {
                            for (const element of this.arrDataCalendar.gestiones_contacto) {
                                const DATE_CALENDAR = new Date(element.fecha_calendario)
                                const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                                let hours = DATE_CALENDAR.getHours()
                                hours = hours < 10 ? `0${hours}` : `${hours}`
                                let minutes = DATE_CALENDAR.getMinutes()
                                minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                                let seconds = DATE_CALENDAR.getSeconds()
                                seconds = seconds < 10 ? `0${seconds}` : seconds
                                const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                                const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                                if (week.getTime() === DATE_VALIDATE.getTime() && HOUR_WEEK === hours ) {
                                    dataClock.dataHour.push({
                                        tipo: 'Gestiones Contacto',
                                        color: '#7C4DFF',
                                        id_convenio: element.id_convenio,
                                        id_gestion: element.id_gestion,
                                        folioGen: element.folioGen,
                                        nombre: element.nombre,
                                        id_cliente: element.id_cliente,
                                        fecha_calendario: element.fecha_calendario,
                                        comentario: element.comentario,
                                        fecha_objeto: DATE_VALIDATE,
                                        hora_objeto: TIME_VALIDATE,
                                        hora: hours,
                                    })
                                }
                            }
                        }
                        if (this.optionIntention) {
                            for (const element of this.arrDataCalendar.intencion) {
                                const DATE_CALENDAR = new Date(element.fecha_calendario)
                                const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                                let hours = DATE_CALENDAR.getHours()
                                hours = hours < 10 ? `0${hours}` : `${hours}`
                                let minutes = DATE_CALENDAR.getMinutes()
                                minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                                let seconds = DATE_CALENDAR.getSeconds()
                                seconds = seconds < 10 ? `0${seconds}` : seconds
                                const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                                const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                                if (week.getTime() === DATE_VALIDATE.getTime() && HOUR_WEEK === hours ) {
                                    dataClock.dataHour.push({
                                        tipo: 'Intención',
                                        color: '#EC407A',
                                        id_convenio: element.id_convenio,
                                        id_gestion: element.id_gestion,
                                        folioGen: element.folioGen,
                                        nombre: element.nombre,
                                        id_cliente: element.id_cliente,
                                        fecha_calendario: element.fecha_calendario,
                                        comentario: element.comentario,
                                        fecha_objeto: DATE_VALIDATE,
                                        hora_objeto: TIME_VALIDATE,
                                        hora: hours,
                                    })
                                }
                            }
                        }
                        if (this.optionPendingLiquidations) {
                            for (const element of this.arrDataCalendar.liquidaciones_pendientes) {
                                const DATE_CALENDAR = new Date(element.fecha_calendario)
                                const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                                let hours = DATE_CALENDAR.getHours()
                                hours = hours < 10 ? `0${hours}` : `${hours}`
                                let minutes = DATE_CALENDAR.getMinutes()
                                minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                                let seconds = DATE_CALENDAR.getSeconds()
                                seconds = seconds < 10 ? `0${seconds}` : seconds
                                const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                                const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                                if (week.getTime() === DATE_VALIDATE.getTime() && HOUR_WEEK === hours ) {
                                    dataClock.dataHour.push({
                                        tipo: 'Liquidaciones Pendientes',
                                        color: '#3FCC1C',
                                        id_convenio: element.id_convenio,
                                        id_gestion: element.id_gestion,
                                        folioGen: element.folioGen,
                                        nombre: element.nombre,
                                        id_cliente: element.id_cliente,
                                        fecha_calendario: element.fecha_calendario,
                                        comentario: element.comentario,
                                        fecha_objeto: DATE_VALIDATE,
                                        hora_objeto: TIME_VALIDATE,
                                        hora: hours,
                                    })
                                }
                            }
                        }
                        if (this.optionPendingpayments) {
                            for (const element of this.arrDataCalendar.pagos_pendientes) {
                                const DATE_CALENDAR = new Date(element.fecha_calendario)
                                const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                                let hours = DATE_CALENDAR.getHours()
                                hours = hours < 10 ? `0${hours}` : `${hours}`
                                let minutes = DATE_CALENDAR.getMinutes()
                                minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                                let seconds = DATE_CALENDAR.getSeconds()
                                seconds = seconds < 10 ? `0${seconds}` : seconds
                                const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                                const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                                if (week.getTime() === DATE_VALIDATE.getTime() && HOUR_WEEK === hours ) {
                                    dataClock.dataHour.push({
                                        tipo: 'Pagos Pendientes',
                                        color: '#DC1818',
                                        id_convenio: element.id_convenio,
                                        id_gestion: element.id_gestion,
                                        folioGen: element.folioGen,
                                        nombre: element.nombre,
                                        id_cliente: element.id_cliente,
                                        fecha_calendario: element.fecha_calendario,
                                        comentario: element.comentario,
                                        fecha_objeto: DATE_VALIDATE,
                                        hora_objeto: TIME_VALIDATE,
                                        hora: hours,
                                    })
                                }
                            }
                        }
                        if(this.optionSettlementsMade){
                            for (const element of this.arrDataCalendar.liquidaciones_realizadas) {
                                const DATE_CALENDAR = new Date(element.fecha_calendario)
                                const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                                let hours = DATE_CALENDAR.getHours()
                                hours = hours < 10 ? `0${hours}` : `${hours}`
                                let minutes = DATE_CALENDAR.getMinutes()
                                minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                                let seconds = DATE_CALENDAR.getSeconds()
                                seconds = seconds < 10 ? `0${seconds}` : seconds
                                const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                                const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                                if (week.getTime() === DATE_VALIDATE.getTime() && HOUR_WEEK === hours ) {
                                    dataClock.dataHour.push({
                                        tipo: 'Liquidaciones Realizadas',
                                        color: '#35530E',
                                        id_convenio: element.id_convenio,
                                        id_gestion: element.id_gestion,
                                        folioGen: element.folioGen,
                                        nombre: element.nombre,
                                        id_cliente: element.id_cliente,
                                        fecha_calendario: element.fecha_calendario,
                                        comentario: element.comentario,
                                        fecha_objeto: DATE_VALIDATE,
                                        hora_objeto: TIME_VALIDATE,
                                        hora: hours,
                                    })
                                }
                            }
                        }
                        if(this.optionPaymentsMade){
                            for (const element of this.arrDataCalendar.pagos_realizados) {
                                const DATE_CALENDAR = new Date(element.fecha_calendario)
                                const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                                let hours = DATE_CALENDAR.getHours()
                                hours = hours < 10 ? `0${hours}` : `${hours}`
                                let minutes = DATE_CALENDAR.getMinutes()
                                minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                                let seconds = DATE_CALENDAR.getSeconds()
                                seconds = seconds < 10 ? `0${seconds}` : seconds
                                const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                                const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                                if (week.getTime() === DATE_VALIDATE.getTime() && HOUR_WEEK === hours ) {
                                    dataClock.dataHour.push({
                                        tipo: 'Pagos Realizados',
                                        color: '#999494',
                                        id_convenio: element.id_convenio,
                                        id_gestion: element.id_gestion,
                                        folioGen: element.folioGen,
                                        nombre: element.nombre,
                                        id_cliente: element.id_cliente,
                                        fecha_calendario: element.fecha_calendario,
                                        comentario: element.comentario,
                                        fecha_objeto: DATE_VALIDATE,
                                        hora_objeto: TIME_VALIDATE,
                                        hora: hours,
                                    })
                                }
                            }
                        }

                        infoWeek.dataDates.push(dataClock)
                    }
                    this.arrDataWeeks.push(infoWeek)
                }
            },
            _generateDate: async function () {

                const dateSelectedYear = this.dateSelected.getFullYear()
                const dateSelectedMonth = this.dateSelected.getMonth()
                const dateSelectedDate = this.dateSelected.getDate()
            
                this.arrDataDate = []
                for (const clock of this.arrTimes) {
                    
                    let dataClock = {
                        hour: clock.hour,
                        dataHour: []
                    }
                    if (this.optionCanceledAgreements) {
                        for (const element of this.arrDataCalendar.convenios_cancelados) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`
                            
                            const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 
                            if (this.dateSelected.getTime() === DATE_VALIDATE.getTime() && HOUR_WEEK === hours ) {
                                dataClock.dataHour.push({
                                    tipo: 'Convenio Cancelado',
                                    color: '#0D47A1',
                                    id_convenio: element.id_convenio,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE,
                                    hora: hours,
                                })
                            }
                        }
                    }
                    if (this.optionPendingAgreements) {
                        for (const element of this.arrDataCalendar.convenios_pendientes) {
                            
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                            const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}`
                            
                            if (
                                dateSelectedYear == DATE_CALENDAR.getFullYear() && 
                                dateSelectedMonth == DATE_CALENDAR.getMonth() && 
                                dateSelectedDate == DATE_CALENDAR.getDate() && 
                                HOUR_WEEK === hours 
                            ) {
                                dataClock.dataHour.push({
                                    tipo: 'Convenios Pendientes',
                                    color: '#FFB74D',
                                    id_convenio: element.id_convenio,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE,
                                    hora: hours,
                                })
                            }
                        }
                    }
                    if (this.optionContactManagement) {
                        for (const element of this.arrDataCalendar.gestiones_contacto) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                            const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                            if (
                                dateSelectedYear == DATE_CALENDAR.getFullYear() && 
                                dateSelectedMonth == DATE_CALENDAR.getMonth() && 
                                dateSelectedDate == DATE_CALENDAR.getDate() && 
                                HOUR_WEEK === hours 
                            ) {
                                dataClock.dataHour.push({
                                    tipo: 'Gestiones Contacto',
                                    color: '#7C4DFF',
                                    id_convenio: element.id_convenio,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE,
                                    hora: hours,
                                })
                            }
                        }
                    }
                    if (this.optionIntention) {
                        for (const element of this.arrDataCalendar.intencion) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                            const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                            if (
                                dateSelectedYear == DATE_CALENDAR.getFullYear() && 
                                dateSelectedMonth == DATE_CALENDAR.getMonth() && 
                                dateSelectedDate == DATE_CALENDAR.getDate() && 
                                HOUR_WEEK === hours 
                            ) {
                                dataClock.dataHour.push({
                                    tipo: 'Intención',
                                    color: '#EC407A',
                                    id_convenio: element.id_convenio,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE,
                                    hora: hours,
                                })
                            }
                        }
                    }
                    if (this.optionPendingLiquidations) {
                        for (const element of this.arrDataCalendar.liquidaciones_pendientes) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                            const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                            if (
                                dateSelectedYear == DATE_CALENDAR.getFullYear() && 
                                dateSelectedMonth == DATE_CALENDAR.getMonth() && 
                                dateSelectedDate == DATE_CALENDAR.getDate() && 
                                HOUR_WEEK === hours 
                            ) {
                                dataClock.dataHour.push({
                                    tipo: 'Liquidaciones Pendientes',
                                    color: '#3FCC1C',
                                    id_convenio: element.id_convenio,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE,
                                    hora: hours,
                                })
                            }
                        }
                    }
                    if (this.optionPendingpayments) {
                        for (const element of this.arrDataCalendar.pagos_pendientes) {
                            const DATE_CALENDAR = new Date(element.fecha_calendario)
                            const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                            let hours = DATE_CALENDAR.getHours()
                            hours = hours < 10 ? `0${hours}` : `${hours}`
                            let minutes = DATE_CALENDAR.getMinutes()
                            minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                            let seconds = DATE_CALENDAR.getSeconds()
                            seconds = seconds < 10 ? `0${seconds}` : seconds
                            const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                            const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                            if (
                                dateSelectedYear == DATE_CALENDAR.getFullYear() && 
                                dateSelectedMonth == DATE_CALENDAR.getMonth() && 
                                dateSelectedDate == DATE_CALENDAR.getDate() && 
                                HOUR_WEEK === hours 
                            ) {
                                dataClock.dataHour.push({
                                    tipo: 'Pagos Pendientes',
                                    color: '#DC1818',
                                    id_convenio: element.id_convenio,
                                    id_gestion: element.id_gestion,
                                    folioGen: element.folioGen,
                                    nombre: element.nombre,
                                    id_cliente: element.id_cliente,
                                    fecha_calendario: element.fecha_calendario,
                                    comentario: element.comentario,
                                    fecha_objeto: DATE_VALIDATE,
                                    hora_objeto: TIME_VALIDATE,
                                    hora: hours,
                                })
                            }
                        }
                    }
                    if(this.optionSettlementsMade){
                            for (const element of this.arrDataCalendar.liquidaciones_realizadas) {
                                const DATE_CALENDAR = new Date(element.fecha_calendario)
                                const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                                let hours = DATE_CALENDAR.getHours()
                                hours = hours < 10 ? `0${hours}` : `${hours}`
                                let minutes = DATE_CALENDAR.getMinutes()
                                minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                                let seconds = DATE_CALENDAR.getSeconds()
                                seconds = seconds < 10 ? `0${seconds}` : seconds
                                const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                                const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                                if (
                                    dateSelectedYear == DATE_CALENDAR.getFullYear() && 
                                    dateSelectedMonth == DATE_CALENDAR.getMonth() && 
                                    dateSelectedDate == DATE_CALENDAR.getDate() && 
                                    HOUR_WEEK === hours 
                                ) {
                                    dataClock.dataHour.push({
                                        tipo: 'Liquidaciones Realizadas',
                                        color: '#35530E',
                                        id_convenio: element.id_convenio,
                                        id_gestion: element.id_gestion,
                                        folioGen: element.folioGen,
                                        nombre: element.nombre,
                                        id_cliente: element.id_cliente,
                                        fecha_calendario: element.fecha_calendario,
                                        comentario: element.comentario,
                                        fecha_objeto: DATE_VALIDATE,
                                        hora_objeto: TIME_VALIDATE,
                                        hora: hours,
                                    })
                                }
                            }
                        }
                        if(this.optionPaymentsMade){
                            for (const element of this.arrDataCalendar.pagos_realizados) {
                                const DATE_CALENDAR = new Date(element.fecha_calendario)
                                const DATE_VALIDATE = new Date(DATE_CALENDAR.getFullYear(), DATE_CALENDAR.getMonth(), DATE_CALENDAR.getDate())
                                let hours = DATE_CALENDAR.getHours()
                                hours = hours < 10 ? `0${hours}` : `${hours}`
                                let minutes = DATE_CALENDAR.getMinutes()
                                minutes = minutes < 10 ? `0${minutes}` : `${minutes}`
                                let seconds = DATE_CALENDAR.getSeconds()
                                seconds = seconds < 10 ? `0${seconds}` : seconds
                                const TIME_VALIDATE = `${hours}:${minutes}:${seconds}`

                                const HOUR_WEEK = dataClock.hour < 10 ? `0${dataClock.hour}` : `${dataClock.hour}` 

                                if (
                                    dateSelectedYear == DATE_CALENDAR.getFullYear() && 
                                    dateSelectedMonth == DATE_CALENDAR.getMonth() && 
                                    dateSelectedDate == DATE_CALENDAR.getDate() && 
                                    HOUR_WEEK === hours 
                                ) {
                                    dataClock.dataHour.push({
                                        tipo: 'Pagos Realizados',
                                        color: '#999494',
                                        id_convenio: element.id_convenio,
                                        id_gestion: element.id_gestion,
                                        folioGen: element.folioGen,
                                        nombre: element.nombre,
                                        id_cliente: element.id_cliente,
                                        fecha_calendario: element.fecha_calendario,
                                        comentario: element.comentario,
                                        fecha_objeto: DATE_VALIDATE,
                                        hora_objeto: TIME_VALIDATE,
                                        hora: hours,
                                    })
                                }
                            }
                        }

                    this.arrDataDate.push(dataClock)
                }
                
            },
            openDetails: function (info) {
                this.infoDetails = info;
                this.dialogDetails = true;
            },
            redirectClient: async function (id_cliente) {
                const form = {
                    id: id_cliente,
                }
                const strForm = JSON.stringify(form)
                const encForm = await EncryptService.encrypt(strForm)

                const newWindow = window.open(this.$router.resolve({ path: `/SGCCV/access-search-management/${encForm}/general` }).href, '_blank');
                if (newWindow) {
                    newWindow.focus();
                }
            }, 
            redirectDate: async function () {
                this.isLoadCalendar = false

                let lastDateSelected = this.dateSelected;
                switch (this.typeCalendar) {
                    case 'Día':
                        if (lastDateSelected.getMonth() !== this.dateSelected.getMonth()) {
                            this.optionAll = false
                            this.optionCanceledAgreements = false
                            this.optionPendingAgreements = false
                            this.optionContactManagement = false
                            this.optionIntention = false
                            this.optionPendingLiquidations = false
                            this.optionPendingpayments = false
                            this.optionPaymentsMade = false
                            this.optionSettlementsMade = false

                            this.isLoadCalendar = false
                        }
                        await this._generateDate()
                        break;
                    case 'Semana':
                        if (lastDateSelected.getMonth() !== this.dateSelected.getMonth()) {
                            this.optionAll = false
                            this.optionCanceledAgreements = false
                            this.optionPendingAgreements = false
                            this.optionContactManagement = false
                            this.optionIntention = false
                            this.optionPendingLiquidations = false
                            this.optionPendingpayments = false
                            this.optionPaymentsMade = false
                            this.optionSettlementsMade = false

                            this.isLoadCalendar = false
                        }

                        await this._generateWeek();
                        break;
                    case 'Mes':
                        this.optionAll = false
                        this.optionCanceledAgreements = false
                        this.optionPendingAgreements = false
                        this.optionContactManagement = false
                        this.optionIntention = false
                        this.optionPendingLiquidations = false
                        this.optionPendingpayments = false
                        this.optionPaymentsMade = false
                        this.optionSettlementsMade = false

                        this.isLoadCalendar = false

                        await this._generateCalendar();
                        break;
                }
            },
            changeUser: async function () {
                this.optionAll = false
                this.optionCanceledAgreements = false
                this.optionPendingAgreements = false
                this.optionContactManagement = false
                this.optionIntention = false
                this.optionPendingLiquidations = false
                this.optionPendingpayments = false
                this.optionPaymentsMade = false
                this.optionSettlementsMade = false

                this.isLoadCalendar = false

                await this._generateCalendar()
            },

            updateAllOptions: function () {
                this.optionAll = !this.optionAll;
                this.optionCanceledAgreements = this.optionAll;
                this.optionPendingAgreements = this.optionAll;
                this.optionContactManagement = this.optionAll;
                this.optionIntention = this.optionAll;
                this.optionPendingLiquidations = this.optionAll;
                this.optionPendingpayments = this.optionAll;
                this.optionPaymentsMade = this.optionAll;
                this.optionSettlementsMade = this.optionAll;

                this.updateOption();
            }
        }
    }
</script>

<style scoped>
.content_calendar_option {
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: rgb(218,220,224) 1px solid;
}
.calendar_config {
    display: flex;
    align-items: center;
}
.date_selected {
    color: rgb(60,64,67);
    font-size: 22px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 28px;
    white-space: nowrap;
    margin-left: 8px;
}
.content_calendar_data {
    width: 100%;
    display: flex;
    flex-direction: row;
    height: calc(100% - 60px);
}
.options {
    width: 360px;
    margin-right: 8px;
    height: 100%;
    overflow: auto;
}

.calendar {
    width: calc(100% - 368px);
    height: 100%;
    overflow: auto;
}

.number_day {
    font-size: 11px;
    text-transform: uppercase;
    color: #70757A;
    letter-spacing: .8px;
    line-height: 32px;
    text-align: center;
}
.number_day-current_date {
    font-size: 11px;
    text-transform: uppercase;
    color: rgb(26,115,232);
    letter-spacing: .8px;
    line-height: 32px;
    text-align: center;
}

.number_date {
    font-size: 26px;
    letter-spacing: -2.6px;
    line-height: 46px;
    color: rgb(60,64,67);
    text-align: center;
}
.number_date-current_date {
    font-size: 26px;
    letter-spacing: -2.6px;
    line-height: 46px;
    color: #FFFFFF;
    font-weight: 500;
    text-align: center;
    display: flex;
    justify-content: center;
}
.number_date-current_date div {
    background-color: rgb(26,115,232);
    width: 45px;
    border-radius: 50px;
}

.item_date_week {
    width: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-left: 60px;
}

.container_time {
    width: 100%;
    display: flex;
    height: calc(100% - 78px);
    overflow: auto;
}

.content_times {
    width: 60px;
    text-align: end;
}
.item_time {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 62px;
    border-bottom: rgb(218,220,224) 1px solid;
    border-right: rgb(218,220,224) 1px solid;
    font-size: 10px;
    color: #70757A;
    padding-right: 10px;
}

.item_data_time {
    height: 62px;
    border-bottom: rgb(218,220,224) 1px solid;
    border-right: rgb(218,220,224) 1px solid;
    font-size: 10px;
    color: #70757A;
    overflow: auto;
}
.content_data_time {
    width: calc(100% - 50px);
}

.content_data_week {
    width: calc(100% - 50px);
    display: flex;
    flex-direction: row;
}

.content_week_data {
    display: flex;
    flex-direction: row;
    width: calc(100% - 60px);
    margin-left: 60px;
}

.item_week_data {
    width: calc(100% / 7);
}

.container_calendar {
    display: flex;
    flex-direction: column;
    border-left: rgb(218,220,224) 1px solid;
    height: 100%;
}

.item_week {
    width: calc(100% / 7);
    border-right: rgb(218,220,224) 1px solid;
    text-align: center;
    font-size: 11px;
    text-transform: uppercase;
    color: #70757A;
}

.content_week {
    display: flex;
    flex-direction: row;
    width: 100%;
    border-bottom: rgb(218,220,224) 1px solid;
}

.item_week_date {
    width: calc(100% / 7); 
    height: 100%; 
    display: flex; 
    flex-direction: column;
}


.item_date {
    display: flex;
    flex-direction: column;
    width: calc(100% / 7);
    border-right: rgb(218,220,224) 1px solid;
    align-items: center;
    min-height: 90px;
}

.content_day {
    display: flex;
    flex-direction: row;
    width: 100%; 
}

.item_day{
    width: 100%;
    text-align: center;
    padding: 5px 0;
    font-size: 12px;
    color: rgb(60,64,67);
}

.item_day-current_date {
    width: 100%;
    text-align: center;
    padding: 5px 0;
    font-size: 12px;
    background-color: rgb(26,115,232);;
    color: #FFFFFF;
    width: 30px;
    border-radius: 15px;
}

.item_day-another_date {
    width: 100%;
    text-align: center;
    padding: 5px 0;
    font-size: 12px;
    color: rgb(206 212 217);
}

.info_date {
    width: 90%;
    border-radius: 5px;
    font-size: 8pt;
    padding: 1px;
    margin-left: 2px;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    font-weight: 500;
    color: #FFFFFF;
}

.info_date:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
}

.my-custom-item {
    padding: 10px 16px; /* Ajusta el relleno de las opciones */
    font-size: inherit; /* Usa el tamaño de fuente por defecto */
    color: inherit; /* Usa el color de texto por defecto */
    background-color: #fff; /* Fondo blanco */
    
}

</style>